// Scores and review counts recorded from the direct listing pages on 25 September 2026.
// Above Par (Bookabach p9612461) is not a Toka Ridge villa. VRBO mirrors
// Bookabach listings, so its reviews must not be counted a second time.
export const airbnbVillas = [
  { name: "One-bedroom villa", score: 4.96, count: 215, url: "https://www.airbnb.com/rooms/48335585" },
  { name: "Two-bedroom villa", score: 4.98, count: 209, url: "https://www.airbnb.com/rooms/48329914" },
  { name: "Three-bedroom villa", score: 4.97, count: 163, url: "https://www.airbnb.com/rooms/48329280" },
  { name: "Four-bedroom villa", score: 4.94, count: 174, url: "https://www.airbnb.com/rooms/48317669" },
] as const;

export const bookabachVillas = [
  { name: "One-bedroom villa", score: 10, count: 6, url: "https://www.bookabach.co.nz/holiday-accommodation/p9612459" },
  { name: "Two-bedroom villa", score: 9.6, count: 8, url: "https://www.bookabach.co.nz/holiday-accommodation/p9612463" },
  { name: "Three-bedroom villa", score: 10, count: 19, url: "https://www.bookabach.co.nz/holiday-accommodation/p9612460" },
  { name: "Four-bedroom villa", score: 10, count: 11, url: "https://www.bookabach.co.nz/holiday-accommodation/p9612462" },
] as const;

export function reviewAggregate(villas: readonly { score: number; count: number }[]) {
  const count = villas.reduce((total, villa) => total + villa.count, 0);
  return {
    count,
    score: villas.reduce((total, villa) => total + villa.score * villa.count, 0) / count,
  };
}